export const BUCKET_DESCRIPTIONS = {
  all: {
    heading: "Leave in tray",
    description: "Conform LEGO®",
    label: "Required",
  },
  bucket2: {
    heading: "Bucket 2",
    description: "Assembled Non-conform",
    label: "Optional",
  },
  bucket3a: {
    heading: "Bucket 3",
    description: "Non-conform DUPLO®",
    label: "Optional",
  },
  bucket3b: {
    heading: "Bucket 4",
    description: "Poor quality / dirty LEGO",
    label: "Optional",
  },
  bucket3c: {
    heading: "Bucket 5",
    description: "Any non-LEGO branded items",
    label: "Optional",
  },
  bucket3d: {
    heading: "Bucket 6",
    description: "Hazardous",
    label: "Optional",
  },
};
